const AccumulationHelper = {
  futureValue: (p, r, y) => {
    return p * Math.pow(1 + r, y);
  },
  geomSeries: (z, m, n) => {
    var amt;
    if (z === 1.0) {
      amt = n + 1;
    } else {
      amt = (Math.pow(z, n + 1) - 1) / (z - 1);
    }
    if (m >= 1) amt = amt - AccumulationHelper.geomSeries(z, 0, m - 1);

    return amt;
  },
  estimatedSavings: (currentSavings, annualAdd, capital, yrs) => {
    var p = currentSavings; //current savings;
    var c = annualAdd; //annual addition ;
    var r = capital / 100; //2.2% for capital protection fund
    var y = yrs; //number of years( retirement age - current age)
    var n = 1; //number of times interest compound annually

    var maturity_value =
      AccumulationHelper.futureValue(p, r, y) +
      c * AccumulationHelper.geomSeries(1 + r, 1, y);

    return maturity_value.toFixed(2);
  },

  calc_targetBreakDown: (saving, rate, socialSecurity, IRA) => {
    let grand_total = 0;
    let fromSavings = saving / 20;
    let savings = saving;

    let sum = 0;
    for (let i = 0; i < 20; i++) {
      let returns = savings * rate;
      let total = returns + socialSecurity + IRA * 1;

      grand_total = fromSavings + total;
      savings = savings - fromSavings;

      sum = sum + grand_total;
    }
    console.log(`%cTotal - ${sum / 20}`, "color : red");
    return (sum / 20).toFixed(2);
  },

  //array of numbers
  dropDown_AGE: (min, max) => {
    let arr = [];
    for (let i = min; i <= max; i++) {
      arr.push(i);
    }
    return arr;
  },

  //  divide number proportionally
  divideProportionally: num => {
    let a, b, c;
    a = Math.floor(num / 3);
    b = a;
    c = num - (a + b);
    return [a, b, c];
  },

  // glide path data
  glidePathDataCalc: (
    end_year,
    currentSavings,
    possibleAnnualSavings,
    y1,
    y2,
    y3
  ) => {
    let year = new Date().getFullYear();

    let list = AccumulationHelper.divideProportionally(end_year + 1);

    let NewBarlineData = [];

    for (let j = 0; j <= end_year; j++) {
      let obj = {};

      let selected_portfolio;
      var invest;

      if (j < list[0]) {
        selected_portfolio = +(y3 * 100).toFixed(2);

        invest =
          AccumulationHelper.estimatedSavings(
            currentSavings,
            possibleAnnualSavings,
            selected_portfolio,
            j
          ) * 1;
      } else if (j < list[0] + list[1]) {
        selected_portfolio = +(y2 * 100).toFixed(2);

        let interest =
          (invest + possibleAnnualSavings) * (selected_portfolio / 100);

        invest = invest + possibleAnnualSavings + interest;
      } else {
        selected_portfolio = +(y1 * 100).toFixed(2);

        let interest =
          (invest + possibleAnnualSavings) * (selected_portfolio / 100);

        invest = invest + possibleAnnualSavings + interest;
      }

      obj["year"] = (year * 1 + j).toString();
      obj["investment"] = invest.toFixed(2) * 1;

      NewBarlineData.push(obj);
    }
    return NewBarlineData;
  },

  // glide path table
  glidePathTableData: (end_year, currentSavings, possibleAnnualSavings, y1,y2,y3) => {
    let year = new Date().getFullYear();

    let list = AccumulationHelper.divideProportionally(end_year + 1);

    // let NewBarlineData = [];

    // for (let j = 0; j <= end_year; j++) {
    //   let arr = [];

    //   let selected_portfolio;
    //   var invest;
    //   var _interest = 0;

    //   if (j < list[0]) {
    //     selected_portfolio = 7.43;
    //     invest =
    //       AccumulationHelper.estimatedSavings(
    //         currentSavings,
    //         possibleAnnualSavings,
    //         selected_portfolio,
    //         j
    //       ) * 1;
    //   } else if (j < list[0] + list[1]) {
    //     selected_portfolio = 5.87;

    //     let interest =
    //       (invest + possibleAnnualSavings) * (selected_portfolio / 100);

    //     invest = invest + possibleAnnualSavings + interest;

    //     _interest = interest;
    //   } else {
    //     selected_portfolio = 2.2;

    //     let interest =
    //       (invest + possibleAnnualSavings) * (selected_portfolio / 100);

    //     invest = invest + possibleAnnualSavings + interest;

    //     _interest = interest;
    //   }

    //   arr.push((year * 1 + j).toString());
    //   arr.push(invest.toFixed(2) * 1);
    //   arr.push(+selected_portfolio);
    //   arr.push(_interest);

    //   NewBarlineData.push(arr);
    // }

    var data = [];
    var savings = currentSavings;
    var addition = possibleAnnualSavings;

    for (let i = 0; i <= end_year; i++) {
      let arr = [];
      var fund;
      if (i < list[0]) {
        fund = +(y3 * 100).toFixed(2);
        if (i == 0) {
          let interest = 0;
          let Bal = +(savings - interest).toFixed(2);
          arr.push(
            (year * 1 + i).toString(),
            Bal,
            interest,
            `${fund}%`,
            savings
          );
        } else {
          let interest = +((savings + addition) * (fund / 100)).toFixed(2);
          savings = +(savings + addition + interest).toFixed(2);
          let Bal = +(savings - interest).toFixed(2);
          arr.push(
            (year * 1 + i).toString(),
            Bal,
            interest,
            `${fund}%`,
            savings
          );
        }
      } else if (i < list[0] + list[1]) {
        fund = +(y2 * 100).toFixed(2);

        let interest = +((savings + addition) * (fund / 100)).toFixed(2);
        savings = +(savings + addition + interest).toFixed(2);
        let Bal = +(savings - interest).toFixed(2);
        arr.push((year * 1 + i).toString(), Bal, interest, `${fund}%`, savings);
      } else {
        fund = +(y1 * 100).toFixed(2);

        let interest = +((savings + addition) * (fund / 100)).toFixed(2);
        savings = +(savings + addition + interest).toFixed(2);
        let Bal = +(savings - interest).toFixed(2);
        arr.push((year * 1 + i).toString(), Bal, interest, `${fund}%`, savings);
      }
      data.push(arr);
    }
    return data;
  }
};
export default AccumulationHelper;



// WEBPACK FOOTER //
// ./src/components/pages/Retire/accumulation.helper.js